import React, { useState } from 'react';
import ApplicationList from '../components/application/ApplicationList';
import Modal from '../components/common/Modal';
import InvitationSend from '../components/application/InvitationSend';
import './ApplicationsPage.css';

const ApplicationsPage = () => {
  const [isInviteModalOpen, setInviteModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // Mock data for Phase 2
  const mockApplications = [
    { id: '1', applicantName: 'John Doe', applicantEmail: 'john@example.com', propertyAddress: '123 Main St', status: 'SUBMITTED', createdAt: '2023-10-20T10:00:00Z', updatedAt: '2023-10-25T14:30:00Z' },
    { id: '2', applicantName: 'Jane Smith', applicantEmail: 'jane@example.com', propertyAddress: '45 Oak Ave', status: 'INVITED', createdAt: '2023-10-24T09:00:00Z', updatedAt: '2023-10-24T09:00:00Z' },
    { id: '3', applicantName: 'Alice Johnson', applicantEmail: 'alice@example.com', propertyAddress: '123 Main St', status: 'VERIFICATION_IN_PROGRESS', createdAt: '2023-10-18T11:20:00Z', updatedAt: '2023-10-26T08:15:00Z' }
  ];

  const handleSendInvite = (data) => {
    setIsSending(true);
    // Mock API call
    setTimeout(() => {
      setIsSending(false);
      setInviteModalOpen(false);
      alert('Invitation sent successfully!');
    }, 1000);
  };

  return (
    <div className="applications-page">
      <div className="page-header">
        <h1 className="page-title">Applications</h1>
        <button className="btn-primary" onClick={() => setInviteModalOpen(true)}>
          Invite Applicant
        </button>
      </div>
      
      <div className="card">
        <div className="card-body">
          <ApplicationList applications={mockApplications} loading={false} />
        </div>
      </div>

      <Modal isOpen={isInviteModalOpen} onClose={() => setInviteModalOpen(false)} title="New Application Request" size="md">
        <InvitationSend 
          propertyAddress="123 Main St, Cape Town" // Mock property context
          onSend={handleSendInvite}
          isSending={isSending}
        />
      </Modal>
    </div>
  );
};

export default ApplicationsPage;
